import { Intermediary } from './types';

export const DEMO_INTERMEDIARIES: Intermediary[] = [
  {
    id: 1,
    name: 'Beaulieu Wines',
    subtitle: 'Top mover · UK on-trade',
    type: 'Importer',
    flagCode: 'uk',
    markets: 'UK, IE',
    onTradeClients: 24,
    bottlesSold: 18420,
    yoyPercent: 34,
    performanceGrade: 'A+',
    performancePercent: 94
  },
  {
    id: 2,
    name: 'Vincent & Cie',
    subtitle: 'Négociant · Place de Bordeaux',
    type: 'Négociant',
    flagCode: 'fr',
    markets: 'FR, BE, CH, DE',
    onTradeClients: 18,
    bottlesSold: 32140,
    yoyPercent: 18,
    performanceGrade: 'A',
    performancePercent: 86
  },
  {
    id: 3,
    name: 'Vinum Nordic',
    subtitle: 'Importer · Scandinavia',
    type: 'Importer',
    flagCode: 'no',
    markets: 'NO, SE, DK, FI',
    onTradeClients: 16,
    bottlesSold: 12860,
    yoyPercent: 22,
    performanceGrade: 'A',
    performancePercent: 82
  },
  {
    id: 4,
    name: 'Vinum Korea',
    subtitle: 'Importer · prestige on-trade focus',
    type: 'Importer',
    flagCode: 'kr',
    markets: 'KR',
    onTradeClients: 11,
    bottlesSold: 6420,
    yoyPercent: 28,
    performanceGrade: 'B+',
    performancePercent: 78
  },
  {
    id: 5,
    name: 'Weinhaus Schmidt',
    subtitle: 'Importer · DACH region',
    type: 'Importer',
    flagCode: 'de',
    markets: 'DE, AT, CH',
    onTradeClients: 14,
    bottlesSold: 21840,
    yoyPercent: 8,
    performanceGrade: 'B',
    performancePercent: 64
  },
  {
    id: 6,
    name: 'Tokyo Fine Wines',
    subtitle: 'Importer · prestige Tokyo focus',
    type: 'Importer',
    flagCode: 'jp',
    markets: 'JP',
    onTradeClients: 9,
    bottlesSold: 4820,
    yoyPercent: 15,
    performanceGrade: 'B+',
    performancePercent: 72
  },
  {
    id: 7,
    name: 'North Atlantic Wines',
    subtitle: 'Importer · US East Coast',
    type: 'Importer',
    flagCode: 'us',
    markets: 'US-East',
    onTradeClients: 22,
    bottlesSold: 28720,
    yoyPercent: -6,
    performanceGrade: 'B−',
    performancePercent: 48
  },
  {
    id: 8,
    name: 'Cave Privée Genève',
    subtitle: 'Négociant · prestige Suisse',
    type: 'Négociant',
    flagCode: 'ch',
    markets: 'CH',
    onTradeClients: 7,
    bottlesSold: 3180,
    yoyPercent: 4,
    performanceGrade: 'B',
    performancePercent: 56
  },
  {
    id: 9,
    name: 'Shanghai Premier',
    subtitle: 'Importer · Greater China',
    type: 'Importer',
    flagCode: 'cn',
    markets: 'CN, HK, TW',
    onTradeClients: 13,
    bottlesSold: 9240,
    yoyPercent: -18,
    performanceGrade: 'C+',
    performancePercent: 32
  },
  {
    id: 10,
    name: 'Emirates Fine Wine',
    subtitle: 'Importer · UAE on-trade',
    type: 'Importer',
    flagCode: 'ae',
    markets: 'AE',
    onTradeClients: 5,
    bottlesSold: 1820,
    yoyPercent: 42,
    performanceGrade: 'B+',
    performancePercent: 68
  }
];
